import React, { useState } from 'react';
import './mobile-nav-bar.style.less';
import { Divider } from 'antd';
import { CloseOutlined, MenuOutlined } from '@ant-design/icons';
import { useLocation, withRouter } from "react-router-dom";
import MenuDropdown from './MenuDropdown';

const MobileNavBar = (props) => {
    const { moveToTop } = props;

    const [menuVisible, setMenuVisible] = useState(false);

    const location = useLocation();

    const toggleMenuDropdown = () => {
        setMenuVisible(!menuVisible);
    };

    const onHeaderClick = () => {
        if (location && location?.pathname?.includes("financing")) {
            return props.history.push("/");
        }

        return moveToTop && moveToTop();
    };

    return (
        <div className="mobile-nav-bar-wrapper">
            <nav className="main-header-nav-wrapper">
                <ul className="main-header-list-wrapper">
                    <li className="main-header-logo">
                        <div className="main-header-logos-wrapper" onClick={onHeaderClick}>
                            <img
                                src={require("../../assets/images/Landing-Page-Mobile/SafEarth-nav-bar-logo.png")}
                            />
                            <Divider type="vertical" />
                            <img
                                src={require("../../assets/images/Landing-Page/Solar-Flow-Nav-Logo.png")}
                                className="solar-flow-nav-logo"
                            />
                        </div>
                    </li>
                    <li>
                        {menuVisible ? <CloseOutlined onClick={() => toggleMenuDropdown()} /> : <MenuOutlined onClick={() => toggleMenuDropdown()} />}
                    </li>
                </ul>
                <MenuDropdown menuVisible={menuVisible} setMenuVisible={setMenuVisible} moveTo={moveToTop} />
            </nav>
        </div>
    )
};

export default withRouter(MobileNavBar);
